import brain from '../assets/brain.webp';
import fire from '../assets/fire.webp';
import goat from '../assets/goat.webp';
import heart from '../assets/heart.webp';
import laugh from '../assets/laugh.webp';

export const getReactionImage = (reaction: string) => {
  switch (reaction) {
    case 'BRAIN':
      return brain;
    case 'FIRE':
      return fire;
    case 'GOAT':
      return goat;
    case 'HEART':
      return heart;
    case 'TEARS_OF_JOY':
      return laugh;
    default:
      return null;
  }
};
